import type { Client } from "viem";
import { avalanche } from "wagmi/chains";
import { publicClient } from "./wagmi";

export const simpleRpcProvider = () =>
	publicClient({ chainId: avalanche.id }) as Client;
